import { registerSW } from 'virtual:pwa-register'
import { swNeedRefresh } from '@/composables/swUpdateSignal'

// Regelmäßig nach einem neuen Service Worker suchen: Der frisch deployte
// Worker landet dadurch schon im `waiting`-Zustand (Aktivierung beim Update
// ist dann sofort möglich) und `onNeedRefresh` liefert den Schnellpfad für
// die Update-Erkennung (~60 s statt bis zu 5 min Poll-Intervall).
const SW_UPDATE_INTERVAL_MS = 60 * 1000

export const updateServiceWorker = registerSW({
  immediate: true,
  // `registerType: 'prompt'`: Der neue Worker wartet passiv, bis
  // useVersionCheck den Reload orchestriert (Banner → Countdown →
  // SKIP_WAITING). Hier wird nur das Erkennungs-Signal gesetzt.
  onNeedRefresh() {
    swNeedRefresh.value = true
  },
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return
    window.setInterval(() => {
      void registration.update()
    }, SW_UPDATE_INTERVAL_MS)
  },
})
